import React from 'react';
import { NumberInput } from '@cad-arc';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';
import { FieldPath, FieldValues } from 'react-hook-form';

type NumberInputProps = React.ComponentProps<typeof NumberInput>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    numberInputProps?: NumberInputProps;
    cRef?: React.Ref<HTMLInputElement>; // 	https://fettblog.eu/typescript-react-generic-forward-refs/
};

export function FormNumberInput<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const { numberInputProps, ...integratedFormControlProps } = props;
    const numberInputPropsMemo = React.useMemo(() => numberInputProps ?? {}, [numberInputProps]);
    const renderViewMode = React.useCallback((value: number) => value?.toString(), []);
    return (
        <IntegratedFormControl {...integratedFormControlProps} renderViewMode={renderViewMode}>
            {(providedProps) => <NumberInput {...providedProps} {...numberInputPropsMemo} />}
        </IntegratedFormControl>
    );
}
